import type { ChartLocation } from "./useChartData";

/** Compute average score per category across all locations */
export function computeCategoryAverages(locations: ChartLocation[]): Record<string, number> {
  const totals: Record<string, { sum: number; count: number }> = {};
  for (const loc of locations) {
    for (const cs of loc.categoryScores) {
      const entry = totals[cs.categoryName] ?? { sum: 0, count: 0 };
      entry.sum += cs.score;
      entry.count += 1;
      totals[cs.categoryName] = entry;
    }
  }
  const avgs: Record<string, number> = {};
  for (const [name, { sum, count }] of Object.entries(totals)) {
    avgs[name] = count > 0 ? Math.round(sum / count) : 0;
  }
  return avgs;
}

/** Shorten a category name for compact column/axis labels */
export function shortLabel(name: string): string {
  const words = name.split(/\s*[&,/]\s*/);
  const first = words[0] ?? name;
  return first.length > 10 ? `${first.slice(0, 8)}…` : first;
}

export function truncate(text: string | undefined | null, maxLen: number): string {
  if (!text) return "";
  return text.length > maxLen + 3 ? `${text.slice(0, maxLen)}...` : text;
}
